define('services/qm/recordingNotificationService',[
    'lib/lodash4',
    'lib/knockout',
    'lib/bluebird',
    'services/toastService',
    'services/authService',
    'services/navHelper',
    'services/notificationService'
], function (_, ko, Promise, toastService, authService, navHelper, notificationService) {
    "use strict";

    var CLICK_NOTIFICATION_TOPIC = "recordings.notification.click";

    var onRecordingNotification = function (recording) {
        var conversationId = recording.conversationId;
        var fileState = recording.fileState;

        if (conversationId && fileState === "RESTORED") {
            toastService.notifyMessage("recordings.notification.message.title", {
                bodyMessageKey: 'recordings.notification.message.body',
                icon: "fa fa-archive",
                publishOnUserInteraction: {
                    topic: CLICK_NOTIFICATION_TOPIC,
                    data: recording
                }
            });
        }
    };

    var openItem = function (recording) {
        navHelper.redirectTo('admin/interactions/' + recording.conversationId);
    };

    // Subscribe to user interaction events for new recording notifications
    toastService.subscribeToUserInteraction(CLICK_NOTIFICATION_TOPIC, openItem);

    ko.computed(function () {
        var recordingsTopicName = 'users.' + authService.principalId() + '.recordings';
        if (authService.principalId()) {
            notificationService.subscribe(recordingsTopicName, onRecordingNotification);
        } else {
            notificationService.unsubscribe(recordingsTopicName);
        }
    });
});

